import { Injectable } from '@angular/core';
import { DataService } from '../../../../../shared/services/data.service';
import { Result } from '../../../../../shared/model/response.model';
import { BehaviorSubject, map, Observable, switchMap, tap } from 'rxjs';
import { AlternativePaginationModel, ConsignmentPaginationModel, FilesPaginationModel, InStockPaginationModel, LineHistoryPaginationModel, OfferPaginationModel, PartListPaginationModel, TablePaginationModel, VPLPaginationModel } from '../../../../../shared/components/ag-grid/ag-grid.model';
import { StorageService } from '../../../../../shared/services/storage.service';
import { Operations } from '../../../../../shared/model/filter.model';

@Injectable({
  providedIn: 'root'
})
export class PartsListService {
  partListPaginationModel = new PartListPaginationModel();
  private partListSubject = new BehaviorSubject<any>(undefined);
  partList$ = this.partListSubject.asObservable();
  btnNext:boolean = false;
  public id:string;
  rowData:any
  onRowClicked = new BehaviorSubject<boolean>(false);
  inventoryListUpdated = new BehaviorSubject<boolean>(false);
  private count = new BehaviorSubject<any>(undefined);
  private data = new BehaviorSubject<any>(undefined);

   constructor(private service:DataService,public storageService:StorageService) { }
     popupIsOpen:boolean = false
     setCount(data: any): void {
       this.count.next(data);
     }
     getCount(): Observable<any> {
       return this.count.asObservable();
     }
     setInfoList(data: any): void {
      this.data.next(data);
    }
    getInfoList(): Observable<any> {
      return this.data.asObservable();
    }

   allPartDropdownList(): Observable<any> {
    return this.getAllPartDropdown();
  }

  insertParts(data: any): Observable<Result> {
    let url = "app/parts_Inventory/addParts";
    return this.service.post(url, data).pipe(
      tap((response: any) => {
      }),
      switchMap((response) => 
        this.getAllPartList(this.partListPaginationModel,true).pipe(
          map(() => response) // Ensure original response is returned
        )
      )
    );
  }
  updateParts(data: any): Observable<Result> {
    let url = "app/parts_Inventory/updateParts";
    return this.service.post(url, data).pipe(
      tap((response: any) => {
      }),
      switchMap((response) => 
        this.getAllPartList(this.partListPaginationModel,true).pipe(
          map(() => response)
        )
      )
    );
  }

    
  getAllPartList(data: PartListPaginationModel,value: boolean = false): Observable<Result> {
    let url = 'app/parts_Inventory/getAllPartList';
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        if(value){this.partListSubject.next(response)}
        return response;
      })
    );
  }
    getAllPartDropdown(): Observable<Result> {
      let url ='app/dropDown/getAllPartDropDownList';
      return this.service.get(url,true).pipe<Result>(tap((response: any) => {
        this.storageService.store('PART_DROPDOWNLIST',response?.response)
       return response;
        })
      );
    }
    getPartInventoryById(id:string): Observable<Result> {
      let url = `app/parts_Inventory/getPartInventoryById?Id=${id}`;
      return this.service.get(url,true).pipe<Result>(tap((response: any) => {
       return response;
        })
      );
    }
    
    addPartInventory(data: any): Observable<Result> {
      let url = "app/parts_Inventory/addPartInventory";
      return this.service.post(url, data).pipe<Result>(
        tap((response: any) => {
          return response;
        })
      );
    }

     getRequirementTransactionsByPartId(data: any): Observable<Result> {
      let url = "app/parts_Inventory/getRequirementTransactionsByPartId";
      return this.service.post(url, data).pipe<Result>(
        tap((response: any) => {
          return response;
        })
      );
    }
    addPartConsignment(data: any): Observable<Result> {
      let url = "app/parts_Inventory/addPartConsignment";
      return this.service.post(url, data).pipe<Result>(
        tap((response: any) => {
          return response;
        })
      );
    }

    getPartDetailById(id:string): Observable<Result> {
      let url = `app/parts_Inventory/getPartDetailsById?Id=${id}`;
      return this.service.get(url,true).pipe<Result>(tap((response: any) => {
       return response;
        })
      );
    }
    getInventoryCategoryDropdownById(request:any,id:string): Observable<Result> {
      let url = `app/dropDown/getInventoryCategoryDropdownListById?${request}=${id}`;
      return this.service.get(url,true).pipe<Result>(tap((response: any) => {
       return response;
        })
      );
    }
  deleteParts(data:any): Observable<Result> {
    let url = 'app/parts_Inventory/deleteParts';
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getInventoryInStockList(data: InStockPaginationModel): Observable<Result> {
    let url = "app/parts_Inventory/getInventoryListByPartId";
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getInventoryConsignmentList(data: ConsignmentPaginationModel): Observable<Result> {
    let url = "app/parts_Inventory/getConsignmentListByPartId";
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  getTabCountById(data: any): Observable<Result> {
    let url = "app/parts_Inventory/getTabCountByIdAndTabName";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getInventoryLineDetailsById(id:string,inventoryId:string): Observable<Result> {
    let url = `app/parts_Inventory/getInventoryLineDetailsByPartInventoryID?Id=${id}&InventoryLineId=${inventoryId}`;
    return this.service.get(url,true).pipe<Result>(tap((response: any) => {
     return response;
      })
    );
  }
  getConsignmentDetailsById(id:string,inventoryId:string): Observable<Result> {
    let url = `app/parts_Inventory/getConsignmentDetailsByPartInventoryID?Id=${id}&InventoryLineId=${inventoryId}`;
    return this.service.get(url,true).pipe<Result>(tap((response: any) => {
     return response;
      })
    );
  }
  getInventoryAlternativeList(data: AlternativePaginationModel): Observable<Result> {
    let url = "app/parts_Inventory/getAllAlternativePartList";
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  addAlternativePart(data: any): Observable<Result> {
    let url = "app/parts_Inventory/addAlternativePart";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
 
  unlinkAlternativePart(data: any): Observable<Result> {
    let url = "app/parts_Inventory/unlinkAlternativePart";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  deleteConsignment(data:any): Observable<Result> {
    let url = "app/parts_Inventory/deletePartConsignments";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getHistoryList(data: InStockPaginationModel): Observable<Result> {
    let url = "app/parts_Inventory/getHistoryByPartId";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getLineHistoryList(data: LineHistoryPaginationModel): Observable<Result> {
    let url = "app/parts_Inventory/getAllInventoryLineHistory";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
 
  addOffers(data: any): Observable<Result> {
    let url = "app/parts_Inventory/addOffer";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  updateOffers(data: any): Observable<Result> {
    let url = "app/parts_Inventory/updateOffer";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response
      })
    )
  }

  uploadTempDocument(data: any): Observable<Result> {
    let url = "app/parts_Inventory/uploadTempDocument";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
 
  getDocumentByInventoryLineId(data: any): Observable<Result> {
    let url = `app/parts_Inventory/getDocumentByInventoryLineId?inventoryLineId=${data.inventoryLineId}`;
    return this.service.get(url, true).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  
  deleteTempDocumentById(data:any): Observable<Result> {
    let url = 'app/parts_Inventory/deleteTempDocumentById';
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getTempDocumentByPartId(data: FilesPaginationModel): Observable<Result> {
    let url = "app/parts_Inventory/getTempDocumentByPartId";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getSourcesOfferList(data: OfferPaginationModel): Observable<Result> {
    let url = "app/parts_Inventory/getAllOfferList";
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getSourcesOEMList(data: any): Observable<Result> {
    let url = "app/parts_Inventory/getAllOEMExcessListByPartId";
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  getSourcesVPLList(data: VPLPaginationModel): Observable<Result> {
    let url = "app/parts_Inventory/getAllVendorPartListByPartId";
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  getViewOfferDetailsById(id:string): Observable<Result> {
    let url = `app/parts_Inventory/getOfferById?Id=${id}`;
    return this.service.get(url,true).pipe<Result>(tap((response: any) => {
     return response;
      })
    );
  }

  expiredOffer(id:any): Observable<Result>{
    let url = "app/parts_Inventory/updateExpired";
    return this.service.post(url,id).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }
  updatequicknote(data:any): Observable<Result>{
    let url ="app/parts_Inventory/editPartNotes";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  partListByVendorId(data: any): Observable<Result> {
    let url = "app/parts_Inventory/getAllVendorPartListByVendorId";
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

}
